import * as hashJs from 'hash.js';

export const sha1 = (value: string): string => hashJs.sha1().update(value).digest('hex');
